module.exports = __webpack_public_path__ + "static/img/icon_js_euser.6be27514.png";